<template>
	<div class="login_wrap">
		<div v-if="loginBackgroundLogo">
			<img :src="loginBackgroundLogo" alt="" class="login-top" />
		</div>
		<div v-else>
			<div v-if="theme !== 'honghui'">
				<img src="@/assets/images/logo@2x.png" alt="" class="login-top" />
			</div>
		</div>
		<div class="login register">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box">
				<ul class="tabs">
					<li class="tab-item">{{ $t('MAIN_WEB_RESET_PASSWORD', { text: '重置密码' }) }}</li>
				</ul>
				<el-form ref="form" :model="forget" :rules="rules">
					<el-form-item prop="account" class="mt32">
						<el-input
							class="phoneInput"
							:placeholder="$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER', { text: '请输入手机号' })"
							v-model="forget.account"
							clearable
						>
							<el-select v-if="isI18nFlag" v-model="code" @change="handleSelectChange" slot="prepend" style="width: 130px" class="phonePrepend" placeholder="请选择">
								<el-option
									:label="internationalKey === 'zh-CN'? item.cn + ' +' + item.mobile_prefix : item.en + ' +' + item.mobile_prefix"
									:value="item.code"
									v-for="item in contryList"
									:key="item.code"
								></el-option>
							</el-select>
						</el-input>
					</el-form-item>
					<el-form-item prop="authCode" class="mt32 input_auth_btn">
						<el-input
							:placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' })"
							v-model="forget.authCode"
							key="authCode"
						>
						</el-input>
						<div class="count_down" @click="postAccountGetAuthCode" :class="{ active_btn: 0 < Countdown.time }">
							{{ 0 >= Countdown.time ? $t('MAIN_WEB_OBTAIN_VERIFICATION_CODE', { text: '获取验证码' }) : countTimer }}
						</div>
					</el-form-item>
					<input type="text" style="position: absolute; display: block; width: 0; height: 0; border-width: 0" />
					<el-form-item prop="password" class="mt32">
						<el-input
							:placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD', { text: '请输入新密码' })"
							v-model="forget.password"
							auto-complete="new-password"
						>
						</el-input>
					</el-form-item>
					<el-form-item class="mt32">
						<el-button type="primary" class="login-btn" @click="onSubmit">{{ $t('MAIN_WEB_OK', { text: '确定' }) }}</el-button>
					</el-form-item>
					<div class="bottom mt16">
						<span class="tip">
							{{ $t('MAIN_WEB_EXISTING_ACCOUNT', { text: '已有账号？' }) }}
							<router-link :to="{ path: '/entrance_new/login', query: { account: this.forget.account,code: this.code } }">{{
								$t('MAIN_WEB_LOG_ON_NOW', { text: '马上登录' })
							}}</router-link>
						</span>
						<div class="clear"></div>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { phoneNumberValidator, passwordValidator, isPhone, isEmail } from '@/util/validate'
import contryList from '../../util/country'
export default {
	name: 'forget',
	data() {
		return {
			Countdown: {
				time: 0,
			},
			forget: {
				account: '',
				password: '',
				authCode: '',
			},
			loginImg: '',
            defaultImg: require('../../assets/images/pexels.png'),
            contryList:[],
            mobile_prefix: '86',
            code:'156',
            internationalKey:'zh-CN',
            isI18nFlag:false,
			loginBackgroundLogo: ''
		}
	},
	computed: {
		...mapState(['theme']),
		countTimer() {
			return this.Countdown.time + 's' + this.$t('MAIN_WEB_THEN_RETRIEVE', { text: '后重新获取' })
		},
		rules() {
			return {
				account: [
					{
						required: true,
						message: this.$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER', { text: '请输入手机号' }),
						trigger: 'blur',
					},
					{
						validator: phoneNumberValidator,
						trigger: 'blur',
						message: this.$t('MAIN_WEB_PLEASE_ENTER_THE_CORRECT_MOBILE_PHONE_NUMBER', { text: '请输入正确的手机号' }),
					},
				],
				password: [
					{ required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_NEW_PASSWORD', { text: '请输入新密码' }), trigger: 'blur' },
					{ validator: passwordValidator, trigger: 'blur' },
				],
				authCode: [
					{ required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' }), trigger: 'blur' },
					{ min: 6, max: 6, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE', { text: '请输入六位验证码' }), trigger: 'blur' },
				],
			}
		},
	},
	created() {
        this.contryList = contryList
        if(this.$route.query.code){
            this.code = this.$route.query.code
            this.handleSelectChange(this.code)
        }
        this.forget.account = this.$route.query.account || ''
        this.internationalKey = localStorage.getItem('current_language') || 'zh-CN'
        this.isI18nFlag = localStorage.getItem('is_i18n') === 'true'
		this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
		var configurationConfig = JSON.parse(localStorage.getItem("configurationConfig"));
		configurationConfig.map((item) => {
			if (item.key === 'login_background_logo') {
				this.loginBackgroundLogo = item.value
			}
		})
	},
	methods: {
        handleSelectChange(val){
            this.mobile_prefix = this.contryList.find(item => item.code === val).mobile_prefix
        },
		onSubmit() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.resetPasswordNew()
				} else {
					return false
				}
			})
		},
		judgeAccountType() {
			if (isPhone.test(this.forget.account)) {
				this.accountType = 'phone'
			}
			if (isEmail.test(this.forget.account)) {
				this.accountType = 'mail'
			}
		},
		resetPasswordNew() {
			this.judgeAccountType()
			if (this.accountType === 'phone') {
				const data = {
					areaCode: this.mobile_prefix,
					authCode: this.forget.authCode,
					newPassword: this.forget.password,
					phone: this.forget.account,
				}
				this.$api.account_new.changePasswordByPhoneAuthCode(data).then((res) => {
					if (res.success) {
						this.$message.success(this.$t('MAIN_WEB_MODIFIED_SUCCESSFULLY', { text: '修改成功' }))
						this.$router.push({
							path: '/entrance_new/login',
							query: {
								account: this.forget.account,
							},
						})
					}
				})
			} else if (this.accountType === 'mail') {
				const data = {
					authCode: this.forget.authCode,
					newPassword: this.forget.password,
					mail: this.forget.account,
				}
				this.$api.account_new.changePasswordByMailAuthCode(data).then((res) => {
					if (res.success) {
						this.$message.success(this.$t('MAIN_WEB_MODIFIED_SUCCESSFULLY', { text: '修改成功' }))
						this.$router.push({
							path: '/entrance_new/login',
							query: {
								account: this.forget.account,
							},
						})
					}
				})
			}
		},
		postAccountGetAuthCode() {
			// 校验手机号、邮箱
			this.$refs.form.validateField('account', (err) => {
				console.log(err, err === '')
				if (!err) {
					if (this.Countdown.time > 0) return
					this.Countdown.time = 60
					this.setCountdown()
					this.judgeAccountType()
					if (this.accountType === 'phone') {
						this.$api.account_new.getPhoneAuthCode4ChangePwd({ phone: this.forget.account, areaCode: this.mobile_prefix })
					} else if (this.accountType === 'mail') {
						this.$api.account_new.getMailAuthCode4ChangePwd({ mail: this.forget.account })
					}
				}
			})
		},
		setCountdown() {
			let Countdown = null

			Countdown = setInterval(() => {
				this.Countdown.time--
				if (Countdown <= 0) {
					clearInterval(Countdown)
				}
			}, 1000)
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './css/index.styl'
.register
  .tabs .tab-item
    margin-bottom 0
    color #000
  .bottom
    .tip
      color #666666
      a
        color #1972FF
        &:hover
          text-decoration:underline
/deep/ .el-form-item__error
  left 0
  padding-top 8px
/deep/ .el-input__inner
  -webkit-box-shadow 0 0 0 1000px #ffffff inset

html[data-theme="red"] {
  .register .bottom .tip a {
    color #EB5461!important
  }
  .bg_width {
    background-color #EB5461!important
  }
  .count_down {
    color #EB5461!important
  }
}

html[data-theme="init"] {
  .register .bottom .tip a {
    color #1972FF!important
  }
  .bg_width {
    background-color #1972FF!important
  }
  .count_down {
    color #1972FF!important
  }
}
</style>
